<div class="card"> 
   <div class="card-header card-no-border">
     <div class="header-top">
       <h5 class="m-0">{{ 'Learning Overview' | translate }}<span class="f-14 f-w-500 ms-1 f-light">{{ '(75% activity growth)' | translate }}</span></h5>
       <div class="card-header-right-icon">
         <div class="dropdown icon-dropdown">
           <button class="btn dropdown-toggle" type="button" (click)="toggle()"><i class="icon-more-alt"></i></button>
           <div class="dropdown-menu dropdown-menu-end" [class.show]="show"><a class="dropdown-item" href="#">{{ 'Today' | translate }}</a><a class="dropdown-item" href="#">{{ 'Tomorrow' | translate }}</a><a class="dropdown-item" href="#">{{ 'Yesterday' | translate }}</a></div>
         </div>
       </div>
     </div>
   </div>
   <div class="card-body pt-0"> 
     <div class="learning-wrap"> 
       <div id="learning-chart">
         <apx-chart [series]="learningChart.series" [chart]="learningChart.chart" [grid]="learningChart.grid" [stroke]="learningChart.stroke" [markers]="learningChart.markers" [tooltip]="learningChart.tooltip" [xaxis]="learningChart.xaxis" [fill]="learningChart.fill" [yaxis]="learningChart.markers" [legend]="learningChart.legend" [responsive]="learningChart.responsive"></apx-chart>
       </div>
     </div>
   </div>
 </div>